import { cn } from "@mabi-ui/utils";
import { Box, Tooltip, Typography } from "@mui/material";
import { useSnapshot } from "valtio";
import { backendMediaUrlParser } from "../../../..";
import { FolderItem } from "../../../../../pages/AuditRooms/pages/SingleAuditRoom/components/AuditRoomTreeListItem/components/FolderItem";
import { TreeViewListItem } from "../../../../controllers/TreeViewController/types/ListItem";
import { useBetterMediaQuery } from "../../../../hooks/useBetterMediaQuery";
import { CertiblokDocument } from "../../../../interfaces/Document";
import BetterCheckbox from "../../../BetterCheckbox";
import FileIcon from "../../../icons/FileIcon";
import {
	useIsPickerDocumentSelected,
	useTreeViewDocumentPickerContext,
} from "../../controllers/TreeViewDocumentPickerContext";
import { useModalNavigator } from "../../../ModalNavigator/ModalNavigator";
import { Button } from "react-aria-components";
import { DocumentPreviewModalProps } from "../../../../../pages/EditRooms/pages/EditRoom/components/DocumentPreviewModal";

const DocumentItem = ({ item }: { item: TreeViewListItem }) => {
	const { selectedDocuments, setSelectedDocuments } = useTreeViewDocumentPickerContext();
	const { pushModalById } = useModalNavigator();
	const itemSnap = useSnapshot(item);
	const isMd = useBetterMediaQuery("md");

	const isSelected = useIsPickerDocumentSelected(itemSnap.item as unknown as CertiblokDocument);

	if (itemSnap.item === undefined || itemSnap.item?.isFolder) return null;

	const document = itemSnap.item as unknown as CertiblokDocument;

	return (
		<div
			// href={`/folders/${itemSnap.parentFolder.folderId}/document/${itemSnap.item.id}`}

			className="justify-start text-black !tracking-[0.25px] w-full h-full flex items-center px-1"
		>
			<Box
				className="grid items-center gap-2 md:gap-4 w-full grid-cols-1"
				// sx={{
				// 	gridTemplateColumns: {
				// 		xs: `1f`,
				// 		sm: `3fr min-content 1fr min-content min-content`,
				// 		md: `3fr 1fr min-content 1fr 1fr min-content min-content`,
				// 	},
				// }}
			>
				<Box
					className="grid items-center gap-4 w-full"
					sx={{
						gridTemplateColumns: {
							xs: `${itemSnap.parentFolder.deepness ? "min-content" : ""} min-content 1fr`,
							md: `repeat(${itemSnap.parentFolder.deepness + 1}, min-content) min-content 1fr`,
						},
					}}
				>
					{isMd ? (
						Array.from(Array(itemSnap.parentFolder.deepness + 1)).map((elem, index) => {
							return <div className={cn("w-[0px] h-[20px]")} key={index} />;
						})
					) : itemSnap.parentFolder.deepness > 0 ? (
						<div className="w-[20px] h-[20px]" />
					) : null}
					<BetterCheckbox
						color="secondary"
						className="p-1"
						checked={isSelected}
						onClick={(ev) => {
							ev.stopPropagation();
							ev.preventDefault();
							if (!itemSnap.item?.id) return;
							if (selectedDocuments.has(itemSnap.item?.id)) {
								setSelectedDocuments(
									Array.from(selectedDocuments.values()).filter((document) => document.id !== itemSnap.item?.id)
								);
							} else {
								setSelectedDocuments([...Array.from(selectedDocuments.values()), document]);
							}
						}}
					/>

					<Button
						onPress={() => {
							setTimeout(() => {
								pushModalById<DocumentPreviewModalProps>(
									"document-preview-modal",
									{
										document,
										shouldRestoreDocument: false,
										version: document.lastVersionFile?.[0],
									},
									{
										shouldHidePrev: false,
									}
								);
							}, 0);
						}}
						className="flex items-center p-2 gap-4 max-w-full w-full overflow-hidden hover:bg-secondary/[0.12] bg-transparent rounded-lg border-none cursor-pointer focus:outline-none focus:bg-secondary/[0.06]"
					>
						<FileIcon
							file={document.lastVersionFile?.[0]}
							dataUrl={backendMediaUrlParser(document?.lastVersionFile?.[0]?.url)}
						/>
						<Tooltip title={document.name} enterDelay={500}>
							<Typography variant="body2" noWrap children={`${document.name}`} className="text-black" />
						</Tooltip>
					</Button>
				</Box>
			</Box>
		</div>
	);
};

export function PickerListItem({ item }: { item: TreeViewListItem }) {
	const itemSnap = useSnapshot(item);
	return itemSnap.item?.isFolder ? <FolderItem item={item} canSelect /> : <DocumentItem item={item} />;
}
